import { AppShell } from './AppShell';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import HubIcon from '@mui/icons-material/Hub';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HistoryIcon from '@mui/icons-material/History';

export function AISafetyLayout() {
  return (
    <AppShell noHeader
      brand={{
        title: 'Clinical Safety',
        subtitle: 'Pillar 10',
        href: '/ai-safety',
      }}
      sections={[
        {
          items: [
            { to: '/ai-safety',              label: 'Models',         icon: <SmartToyIcon />, exact: true },
            { to: '/ai-safety/capabilities', label: 'Capabilities',   icon: <HubIcon /> },
            { to: '/ai-safety/safety-cases', label: 'Safety cases',   icon: <HealthAndSafetyIcon /> },
            { to: '/ai-safety/events',       label: 'Event audit',    icon: <HistoryIcon /> },
          ],
        },
      ]}
    />
  );
}
